import {
  Component,
  inject,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../shared/theming/material/material.module';
import { ApiService } from '../../../../shared/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';
import { PlanNumberRevealService } from '../../../../shared/services/plan-number-reveal.service';

interface FireSafetyInstance {
  pk: string;
  sk: string;
  planNumber?: string;
}

interface FireSafetyInstancesResponse {
  totalCount: number;
  data: FireSafetyInstance[];
}

@Component({
  selector: 'app-fire-safety-instances-widget',
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule],
  templateUrl: './fire-safety-instances-widget.component.html',
  styleUrls: ['./fire-safety-instances-widget.component.scss'],
  providers: [provideNativeDateAdapter()],
})
export class FireSafetyInstancesWidgetComponent implements OnInit, OnChanges {
  private apiService = inject(ApiService);
  private initialized = false;
  private router = inject(Router);
  private planNumberRevealStateService = inject(PlanNumberRevealService);

  startDate: Date | null = null;
  endDate: Date | null = null;
  isLoading: boolean = false;

  isPlanNumberRevealed: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  totalCount = 0;
  dataSource = new MatTableDataSource<FireSafetyInstance>([]);
  displayedColumns: string[] = ['planNumber', 'date'];

  showItems = false;

  ngOnInit(): void {
    this.isPlanNumberRevealed =
      this.planNumberRevealStateService.getIsPlanNumberRevealed();

    this.initialized = true;
    this.getFireSafetyInstances();
  }

  seeFireInstances(): void {
    this.showItems = !this.showItems;
    if (this.showItems) {
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasFilterChanges = !!changes['startDate'] || !!changes['endDate'];

    if (this.initialized && hasFilterChanges) {
      this.getFireSafetyInstances();
    }
  }

  getFireSafetyInstances(): void {
    this.isLoading = true;
    const queryParams: Record<string, string> = {};

    if (this.startDate) {
      queryParams['startDate'] = this.startDate.toISOString();
    }

    if (this.endDate) {
      queryParams['endDate'] = this.endDate.toISOString();
    }

    this.apiService
      .get<FireSafetyInstancesResponse>(
        'admin/get-fire-safety-instances',
        queryParams
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.totalCount = response.totalCount;
          this.dataSource.data = response.data;
        },
      });
  }

  clearData(): void {
    this.startDate = null;
    this.endDate = null;
  }

  refreshData(): void {
    this.getFireSafetyInstances();
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  backToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
